import { ECustomerKind } from '@/helpers/enums';

import { ICustomer } from '@/interfaces/Customer';
import { IAddress } from '@/interfaces/Address';
import { IPhone } from '@/interfaces/Phone';

export default class Customer implements ICustomer {
  public acta_user_id?: string|number = '';
  public external_id?: string|number = '';
  public avatar?: string = '';
  public birthday?: string = '';
  public kind?: ECustomerKind = ECustomerKind.pf;
  public created_at?: string = '';
  public updated_at?: string = '';
  public has_sms?: boolean = true;
  public is_active?: boolean = true;
  public name: string = '';
  public email: string = '';
  public document: string = '';
  public password?: string = '';
  public terms_optin?: boolean|null = false;
  public addresses?: IAddress[] = new Array<IAddress>();
  public phone_numbers?: IPhone[] = new Array<IPhone>();
  public delivery_address?: IAddress = undefined;

  constructor(customer?: ICustomer) {
    Object.assign(this, { ...customer });
  }
}
